import {
  FETCH_PALETTES_REQUEST, FETCH_PALETTES_SUCCEEDED, FETCH_PALETTES_FAILED,
  FETCH_PALETTES_FOR_WORKSPACE_REQUEST, FETCH_PALETTES_FOR_WORKSPACE_SUCCEEDED, FETCH_PALETTES_FOR_WORKSPACE_FAILED,
  FETCH_PALETTE_FOLDERS_REQUEST, FETCH_PALETTE_FOLDERS_SUCCEEDED, FETCH_PALETTE_FOLDERS_FAILED,
  FETCH_COMPONENTS_FOR_PALETTE_REQUEST, FETCH_COMPONENTS_FOR_PALETTE_SUCCEEDED, FETCH_COMPONENTS_FOR_PALETTE_FAILED,
  FETCH_COMPONENTS_FOR_PALETTE_FOLDER_REQUEST, FETCH_COMPONENTS_FOR_PALETTE_FOLDER_SUCCEEDED, FETCH_COMPONENTS_FOR_PALETTE_FOLDER_FAILED,
  FETCH_MEDIA_FOR_PALETTE_REQUEST, FETCH_MEDIA_FOR_PALETTE_SUCCEEDED, FETCH_MEDIA_FOR_PALETTE_FAILED,
  FETCH_PALETTE_COMPONENT_REQUEST, FETCHING_PALETTE_COMPONENT_SUCCEEDED, FETCHING_PALETTE_COMPONENT_FAILED,
  RELOAD_EDITOR_PALETTE_COMPONENT_SUCCEEDED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const PALETTE_API_URL = `${apiUrl}/api/2.0/palette`;
const MEDIA_URL = `${apiUrl}/api/2.0/media`;

/**
 * Fetch Palettes
*/
export const fetchPalettes = createAction(FETCH_PALETTES_REQUEST);

const fetchPalettesSucceeded = createAction(FETCH_PALETTES_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const fetchPalettesFailed = createAction(FETCH_PALETTES_FAILED, (error) => {
  return {
    error: error
  }
})

function* fetchPalettesSaga(action) {

  const fetchPalettesAPI = () => {
    return axios.get(`${PALETTE_API_URL}/default`).then(response => response.data);
  }

  try {
    const response = yield call(fetchPalettesAPI);
    yield put(fetchPalettesSucceeded(response));
  } catch (error) {
    yield put(fetchPalettesFailed(error));
  }
}

/**
 * Fetch Palettes for workspace 
*/
export const fetchPalettesForWorkspace = createAction(FETCH_PALETTES_FOR_WORKSPACE_REQUEST);

export const fetchPalettesForWorkspaceSucceeded = createAction(FETCH_PALETTES_FOR_WORKSPACE_SUCCEEDED, (response) => {
  return {
    response: response
  }
})

export const fetchPalettesForWorkspaceFailed = createAction(FETCH_PALETTES_FOR_WORKSPACE_FAILED, (error) => {
  return {
    error: error
  }
})

function* fetchPalettesForWorkspaceSaga(action) {

  const fetchPalettesForWorkspaceAPI = () => {
    return axios.get(PALETTE_API_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchPalettesForWorkspaceAPI);
    yield put(fetchPalettesForWorkspaceSucceeded(response));
  } catch (error) {
    yield put(fetchPalettesForWorkspaceFailed(error));
  }
}

/**
 * Fetch Folders for Palette {id}
*/
export const fetchPaletteFolders = createAction(FETCH_PALETTE_FOLDERS_REQUEST, (id, type) => {
  return {
    id: id,
    type: type
  }
})

const fetchPaletteFoldersSucceeded = createAction(FETCH_PALETTE_FOLDERS_SUCCEEDED, (id, type, response) => {
  return {
    id: id,
    type: type,
    response: response
  }
})

const fetchPaletteFoldersFailed = createAction(FETCH_PALETTE_FOLDERS_FAILED, (id, type, error) => {
  return {
    id: id,
    type: type,
    error: error
  }
})

function* fetchPaletteFoldersSaga(action) {
  const { id, type } = action.payload;

  const url = buildUrl(PALETTE_API_URL, {
    path: `/${id}/folders`
  });

  const fetchPaletteFoldersAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchPaletteFoldersAPI);
    yield put(fetchPaletteFoldersSucceeded(id, type, response));
  } catch (error) {
    yield put(fetchPaletteFoldersFailed(id, type, error));
  }
}

/**
 * Fetch Components for Palette 
*/
export const fetchComponentsForPalette = createAction(FETCH_COMPONENTS_FOR_PALETTE_REQUEST, (id, type, request,  page, limit) => {
  return {
    id: id,
    type: type,
    request: request,
    page: page,
    limit: limit
  }
})

export const fetchComponentsForPaletteSucceeded = createAction(FETCH_COMPONENTS_FOR_PALETTE_SUCCEEDED, (id, type, response) => {
  return {
    id: id,
    type: type,
    response: response
  }
})

const fetchComponentsForPaletteFailed = createAction(FETCH_COMPONENTS_FOR_PALETTE_FAILED, (id, type, error) => {
  return {
    id: id,
    type: type,
    error: error
  }
})

function* fetchComponentsForPaletteSaga(action) {
  const { id, type, request = {
    sort: 'order',
    order: 'ASC'
  }, page, limit } = action.payload;

  const url = buildUrl(PALETTE_API_URL, {
    path: `/${id}/components?page=${page}&limit=${limit}`
  })

  const fetchComponentsForPaletteAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchComponentsForPaletteAPI);
    yield put(fetchComponentsForPaletteSucceeded(id, type, response));
  } catch (error) {
    yield put(fetchComponentsForPaletteFailed(id, type, error));
  }
}

/**
 * Fetch Components for Palette 
*/
export const fetchMediaForPalette = createAction(FETCH_MEDIA_FOR_PALETTE_REQUEST, (id, type, mediaType, request) => {
  return {
    id: id,
    type: type,
    mediaType: mediaType,
    request: request
  }
})

const fetchMediaForPaletteSucceeded = createAction(FETCH_MEDIA_FOR_PALETTE_SUCCEEDED, (id, type, mediaType, response) => {
  return {
    id: id,
    type: type,
    mediaType: mediaType,
    response: response
  }
})

const fetchMediaForPaletteFailed = createAction(FETCH_MEDIA_FOR_PALETTE_FAILED, (id, type, mediaType, error) => {
  return {
    id: id,
    type: type,
    mediaType: mediaType,
    error: error
  }
})

function* fetchMediaForPaletteSaga(action) {
  const { id, type, mediaType, request } = action.payload;

  const url = buildUrl(MEDIA_URL, {})

  const fetchMediaForPaletteAPI = () => {
    return axios.post(`${MEDIA_URL}/search`, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchMediaForPaletteAPI);
    yield put(fetchMediaForPaletteSucceeded(id, type, mediaType, response));
  } catch (error) {
    yield put(fetchMediaForPaletteFailed(id, type, mediaType, error));
  }
}

/**
 * Fetch Components for Palette Folder {id}
*/
export const fetchComponentsForPaletteFolder = createAction(FETCH_COMPONENTS_FOR_PALETTE_FOLDER_REQUEST, (id, folderId, type, request, page, limit) => {
  return {
    id: id,
    folderId: folderId,
    type: type,
    request: request,
    page: page,
    limit: limit
  }
})

const fetchComponentsForPaletteFolderSucceeded = createAction(FETCH_COMPONENTS_FOR_PALETTE_FOLDER_SUCCEEDED, (id, folderId, type, response) => {
  return {
    id: id,
    folderId: folderId,
    type: type,
    response: response
  }
})

const fetchComponentsForPaletteFolderFailed = createAction(FETCH_COMPONENTS_FOR_PALETTE_FOLDER_FAILED, (id, folderId, type, error) => {
  return {
    id: id,
    folderId: folderId,
    type: type,
    error: error
  }
})

function* fetchComponentsForPaletteFolderSaga(action) {
  const { id, folderId, type, request, page, limit } = action.payload;

  const url = buildUrl(PALETTE_API_URL, {
    path: `/folder/${folderId}/components?page=${page}&limit=${limit}`
  })

  const fetchComponentsForPaletteFolderAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchComponentsForPaletteFolderAPI);
    yield put(fetchComponentsForPaletteFolderSucceeded(id, folderId, type, response));
  } catch (error) { 
    yield put(fetchComponentsForPaletteFolderFailed(id, folderId, type, error));
  }
}

/**
 * Fetch component for {id}
*/
export const fetchPaletteComponent = createAction(FETCH_PALETTE_COMPONENT_REQUEST, id => {
  return id;
})

const fetchingPaletteComponentSucceeded = createAction(FETCHING_PALETTE_COMPONENT_SUCCEEDED, response => {
  return response;
})

const fetchingPaletteComponentFailed = createAction(FETCHING_PALETTE_COMPONENT_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingPaletteComponentSaga(action) {
  const id = action.payload;

  let url = buildUrl(`${PALETTE_API_URL}/component/published`, {
    path: id
  });

  const fetchingPaletteComponentAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchingPaletteComponentAPI);
    yield put(fetchingPaletteComponentSucceeded(response));
  } catch (error) {
    yield put(fetchingPaletteComponentFailed(id, error));
  }
}

export const reloadEditorPaletteComponentSucceed = createAction(RELOAD_EDITOR_PALETTE_COMPONENT_SUCCEEDED, (id, response, type) => {
  return {
    id,
    response,
    type
  };
})


export default function* paletteSaga() {
  yield takeEvery(FETCH_PALETTES_REQUEST, fetchPalettesSaga);
  yield takeEvery(FETCH_PALETTE_FOLDERS_REQUEST, fetchPaletteFoldersSaga);
  yield takeEvery(FETCH_PALETTES_FOR_WORKSPACE_REQUEST, fetchPalettesForWorkspaceSaga);
  yield takeEvery(FETCH_COMPONENTS_FOR_PALETTE_REQUEST, fetchComponentsForPaletteSaga);
  yield takeEvery(FETCH_COMPONENTS_FOR_PALETTE_FOLDER_REQUEST, fetchComponentsForPaletteFolderSaga);
  yield takeEvery(FETCH_MEDIA_FOR_PALETTE_REQUEST, fetchMediaForPaletteSaga);
  yield takeEvery(FETCH_PALETTE_COMPONENT_REQUEST, fetchingPaletteComponentSaga);
}